import { Doughnut } from "react-chartjs-2";
import { Chart, ArcElement, Tooltip, Legend, Colors, ChartData } from "chart.js";
import { Box, Typography } from "@mui/material";

const centerTextPlugin = {
    id: 'centerText',
    beforeDraw: (chart: any) => {
        const text = chart.options?.plugins?.centerText?.text;
        if (!text) return;
        const { ctx, chartArea } = chart;
        if (!chartArea) return;
        ctx.save();
        const fontSize = (chartArea.height / 3).toFixed(2);
        ctx.font = `${fontSize}px sans-serif`;
        ctx.textBaseline = "middle";
        ctx.textAlign = "center";
        const textX = (chartArea.left + chartArea.right) / 2;
        const textY = (chartArea.top + chartArea.bottom) / 2;
        ctx.fillText(text, textX, textY);
        ctx.restore();
    }
};

Chart.register(ArcElement, Tooltip, Legend, centerTextPlugin);

interface DoughnutChartProps {
    chartData: ChartData<"doughnut", number[], string>;
    title?: string;
    centerText?: string;
}

export const DoughnutChart = ({
    chartData,
    title = "",
    centerText = "",
}: DoughnutChartProps) => {
    return (
        <Box sx={{ marginTop: 2, width: "500px", height: "250px", display: "flex", flexDirection: "column", alignItems: "center" }}>
            <Typography variant="h6" sx={{ marginBottom: 1 }}>
                {title}
            </Typography>
            <Doughnut
                data={chartData}
                options={{
                    cutout: "65%",
                    plugins: {
                        legend: {
                            display: true,
                            position: "bottom"
                        },
                        tooltip: {
                            enabled: true
                        },
                        centerText: {
                            text: centerText
                        }
                    }
                } as any}
            />
        </Box>
    );
};